export const types = {
  SET_USER_REQUESTS_BY_CATEGORIES: 'SET_USER_REQUESTS_BY_CATEGORIES',
};

export const topCategoryCount = 8;
